import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Container,
  Spinner,
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Select from "react-select";
import { toast } from "react-toastify";
import { getRecords, saveRecords } from "../../../services/api.service";
import Asterisks from "../../../custom/components/Asterisks/Asterisks";
import SelectInput from "../../../custom/components/Select-Input/SelectInput";
import CheckboxInput from "../../../custom/components/CheckBox-Input/CheckboxInput";

const UserMenuAccess = () => {
  const userType = [
    { label: "Bermad User", value: 1 },
    { label: "Subcontractor", value: 2 },
    { label: "Customer", value: 3 },
  ];
  const [selectedUserType, setSelectedUserType] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const [userlistOptions] = useState(userType);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [UserTypeError, setUserTypeError] = useState(false);
  const [UserError, setUserError] = useState(false);

  const getProjectData = async (selectedUserType) => {
    if (!selectedUserType) {
      setUserTypeError(!selectedUserType ? true : false);
      return;
    }
    const payload = {
      modelName: "user_masters",
      whereCondition: { is_active: true, user_type: selectedUserType?.value },
    };
    const responseData = await getRecords(payload, "/getRecords");
    if (responseData) {
      const projectOptions = responseData.data.map((project) => ({
        label: project.first_name + " " + project.last_name,
        value: project.id,
      }));
      setUserOptions(projectOptions);
    }
  };

  const handleUserTypeSelectChange = (userType) => {
    setSelectedUserType(userType);
    setSelectedUser(null);
    getProjectData(userType);
    setUserTypeError(false);
    setData([]);
  };

  const handleUserSelectChange = (user) => {
    setSelectedUser(user);
    setUserError(false);
    setData([]);
  };

  const handleGo = async () => {
    if (!selectedUserType || !selectedUser) {
      setUserTypeError(!selectedUserType ? true : false);
      setUserError(!selectedUser ? true : false);
      return;
    }

    const payload = {
      modelName: "menu_masters",
      whereCondition: {
        is_active: true,
      },
      pagination: { page: 1, pageSize: 1000000 },
      relations: [
        {
          module: "user_access",
          moduleAs: "user_access",
        },
        {
          module: "user_type_menu_access",
          moduleAs: "user_type_menu_access",
          isModuleWhereConditionRequired: true,
          required: true,
        },
      ],
      moduleWhereCondition: {
        user_type: selectedUserType?.value,
        is_active: true,
        access: true,
      },
    };

    setLoading(true);
    const responseData = await getRecords(payload, "/getRecords");
    setLoading(false);

    if (responseData?.data?.length > 0) {
      const updatedData = responseData.data.map((item) => {
        // Check if the user has access in the user_type_menu_access array
        let userTypeAccess = false
        let primary_id = undefined;

        if (item?.user_access && item?.user_access.length > 0) {
          item?.user_access.forEach((element) => {
            if (
              selectedUser?.value &&
              element?.user_id == selectedUser?.value
            ) {
              primary_id = element.id;
              userTypeAccess = element.access ? true : false;
            }
          });
        }

        return {
          ...item,
          isChecked: userTypeAccess ? true : false, // Set isChecked based on access
          primary_id: primary_id || undefined,
        };
      });
      setData(updatedData);
    } else {
      setData([]);
      toast.info("No menu found for the selected user type.");
    }
  };

  const handleToggleExpand = (id) => {
    setData((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, isExpanded: !item.isExpanded } : item
      )
    );
  };

  const handleCheckboxChange = (id, checked) => {
    setData((prev) =>
      prev.map((item) =>
        item.id === id || item.parent_id === id
          ? { ...item, isChecked: checked }
          : item
      )
    );

    if (checked) {
      const childParentMenuId = data
        .filter((child) => child.id === id)
        .map((child) => child.parent_id)[0];
      if (childParentMenuId) {
        setData((prev) =>
          prev.map((item) =>
            item.id === childParentMenuId
              ? { ...item, isChecked: checked }
              : item
          )
        );
      }
    }
  };
  const handleSubmit = async () => {
    if (!selectedUserType || !selectedUser) {
      toast.error("Please select a user type & user.");
      return;
    }
    const checkedUsers = data
      .filter((user) => user.isChecked)
      .map((user) => user.id); // Extract their IDs
    // Ensure at least one user is selected
    if (checkedUsers.length === 0) {
      toast.error("Please select at least one user.");
      return;
    }

    const payload = {
      modelName: "user_access",
      inputData: data.map((item) => ({
        id: item.primary_id, // Use primary_id (the ID from user_type_menu_access)
        user_type: selectedUserType?.value, // Use selected user type value
        user_id: selectedUser?.value, // Use selected user
        menu_id: item.id,
        access: item.isChecked ?? false,
        is_active: true,
      })),
    };
    // API call to save the records
    try {
      const response = await saveRecords(payload, "/saveRecords");

      if (response.code === 1) {
        setData([]);
        setSelectedUserType(null);
        setSelectedUser(null);
        setUserOptions([]);
        setLoading(false);
        toast.success("Access successfully updated.");
        window.location.reload();
      } else {
        toast.error("Failed to update access.");
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An error occurred while submitting data.");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="MENU ACCESS" breadcrumbItems={[]} />
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Row className="justify-content-center ">
                      <Col md={4}>
                        <SelectInput
                          label="User Type"
                          value={selectedUserType}
                          onSelect={handleUserTypeSelectChange}
                          options={userlistOptions}
                          classNamePrefix="select2-selection"
                          noOptionsMessage={() => "No data found."}
                          maxMenuHeight={200}
                          asterisk={true}
                          isClearable={true}
                          customError={
                            (UserTypeError && "Please select a user type.") ||
                            ""
                          }
                        />
                      </Col>

                      <Col md={4}>
                        <SelectInput
                          label="User"
                          value={selectedUser}
                          onSelect={handleUserSelectChange}
                          options={userOptions}
                          classNamePrefix="select2-selection"
                          noOptionsMessage={() => "No data found."}
                          maxMenuHeight={200}
                          asterisk={true}
                          isClearable={true}
                          customError={
                            (UserError && "Please select a user.") || ""
                          }
                        />
                      </Col>

                      <Col style={{ marginTop: "28px", paddingBottom: "20px" }}>
                        <Button
                          onClick={handleGo}
                          color="primary"
                          type="button"
                          className="waves-effect waves-light me-1"
                          style={{ background: "#006eb9" }}>
                          Go
                        </Button>
                      </Col>
                    </Row>
                    <Row
                      className="justify-content-center"
                      style={{ maxHeight: "55vh", overflowY: "auto" }}>
                      {loading ? (
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                          <Spinner color="primary" />
                        </div>
                      ) : (
                        <Row style={{ paddingBlock: "12px", width: "100%" }}>
                          <Col xl="12" className="mt-1">
                            <table className="table table-bordered">
                              <thead style={{ backgroundColor: "#8AC1E8" }}>
                                <tr>
                                  <th>Menu Name</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data.length > 0 ? (
                                  data
                                    .filter((item) => item.parent_id === null) // Render only parent menus initially
                                    .map((parent) => (
                                      <React.Fragment key={parent.id}>
                                        <tr>
                                          <td
                                            style={{
                                              cursor: "pointer",
                                              fontWeight: "bold",
                                            }}
                                            onClick={() =>
                                              handleToggleExpand(parent.id)
                                            }>
                                            {parent.isExpanded ? "▼" : "▶"}{" "}
                                            {parent.menu_name}
                                          </td>
                                          <td>
                                            <CheckboxInput
                                              value={parent?.isChecked}
                                              checked={parent?.isChecked}
                                              handleTextChange={(e) =>
                                                handleCheckboxChange(
                                                  parent?.id,
                                                  e.target.checked
                                                )
                                              }
                                              parentClassName="form-check"
                                              checkBoxClassName="form-check-input"
                                              labelClassName="form-check-label"
                                              labelStyle={{
                                                display: "none",
                                              }}
                                              checkboxStyle={{
                                                width: "16px",
                                                height: "16px",
                                              }}
                                            />
                                          </td>
                                        </tr>
                                        {parent.isExpanded &&
                                          data
                                            .filter(
                                              (child) =>
                                                child.parent_id === parent.id
                                            )
                                            .map((child) => (
                                              <tr
                                                key={child.id}
                                                style={{
                                                  paddingLeft: "20px",
                                                }}>
                                                <td>
                                                  &emsp;↳ {child.menu_name}
                                                </td>
                                                <td>
                                                  <CheckboxInput
                                                    value={child?.isChecked}
                                                    checked={child?.isChecked}
                                                    handleTextChange={(e) =>
                                                      handleCheckboxChange(
                                                        child?.id,
                                                        e.target.checked
                                                      )
                                                    }
                                                    parentClassName="form-check"
                                                    checkBoxClassName="form-check-input"
                                                    labelClassName="form-check-label"
                                                    labelStyle={{
                                                      display: "none",
                                                    }}
                                                    checkboxStyle={{
                                                      width: "16px",
                                                      height: "16px",
                                                    }}
                                                  />
                                                </td>
                                              </tr>
                                            ))}
                                      </React.Fragment>
                                    ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan="2"
                                      style={{ textAlign: "center" }}>
                                      No menus found.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </Col>
                        </Row>
                      )}
                    </Row>

                    {data.length > 0 && (
                      <Row className="mt-4 justify-content-center">
                        <Col
                          style={{
                            paddingTop: "10px",
                            borderTop: "1px solid #ced4da",
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center",
                          }}>
                          <Button color="primary" onClick={handleSubmit}>
                            Submit
                          </Button>
                        </Col>
                      </Row>
                    )}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UserMenuAccess;
